export default __webpack_public_path__ + "static/media/caret-disabled.ed08d58b.svg";